import { TRuleWithTheme } from '@ackee/fela';

export const container: TRuleWithTheme<{ overlayColor?: string }> = ({ overlayColor }) => {
    return {
        '&.pixelated::before': {
            content: '" "',
            display: 'block',
            position: 'absolute',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            backgroundColor: overlayColor ?? 'rgba(0, 0, 255, 0.78)',
            zIndex: '400',
        },

        '& img': {
            transition: 'transform .4s ease, opacity 500ms ease 0s!important',
            backfaceVisibility: 'hidden',
            '-webkit-backface-visibility': 'hidden',
        },
        '&.testimonialPic.show': {
            width: '3.125rem',
            height: '3.125rem',
        },
    };
};

export const cta: TRuleWithTheme = ({ theme: { colors } }) => ({
    color: colors.white,
    alignSelf: 'end',
    marginTop: 'auto',
    marginBottom: '2rem',
    marginRight: '2rem',
    textDecoration: 'underline',
    textDecorationThickness: 2,
    textUnderlineOffset: '5px',
    fontSize: '20px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '24px', /* 120% */
    letterSpacing: '0.136px',
});

export const testimonial: TRuleWithTheme = ({ theme: { colors } }) => ({
    display: 'flex',
    flexDirection: 'column',
    marginLeft: '1rem',
    gap: '1.5rem',
    '& span[class^=Text_text_]': {
        color: colors.white,
    },
});

export const quotes: TRuleWithTheme = () => ({
    width: '1.875rem',
    height: '1.5rem',
});

export const overlayTextContainer: TRuleWithTheme = () => ({
    position: 'absolute',
    top: '0',
    padding: '2.63rem 1.75rem 1rem',
    zIndex: 500,
    height: 'calc(100% - 3.63rem)',
    display: 'flex',
    overflow: 'scroll',
    minWidth: 'calc(100% - 3.5rem)'
});

export const testimonialText: TRuleWithTheme = () => ({
    marginRight: '2rem',
    color: 'white',
    marginBottom: '2rem',
    lineHeight: '26px',
    maxWidth: 750,
    '& span': {
        color: 'white!important'
    }

});
